_collow.components.Notifications = class Notifications extends (
  _collow.components.Base
) {
  root;
  elements;
  params;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    this.listen(document.body, "change.localstorage", this.renderNotifications);
    this.renderNotifications();
  }
  renderNotifications = () => {
    const notifications = localStorage.getItem("notifications");

    if (!notifications) return;
    const template = elements.template.innerHTML;
    const htmlNotifications = JSON.parse(notifications)
      .map((msg) =>
        template
          .replace("msg", msg.message)
          .replace("date", msg["send_datetime"])
          .replace('src=""', `src="${msg.logo_url}"`)
      )
      .join("\n");
    elements.container.insertAdjacentHTML("beforeend", htmlNotifications);

    elements.container.childNodes.forEach((el) =>
      this.listen(el, "click", this.notificationClickHandler)
    );
  };

  notificationClickHandler = ({ target }) => {
    const targetId = target.closest(".company-notification__element").dataset
      .id;
    this.dispatch(this.root, ".collow.notification.read", { id: targetId });
  };
};
